/* tslint:disable */
/* eslint-disable */
/**
 * order-retrieval
 * Order Retrieval - retrieves order information given the ordernumber
 *
 * The version of the OpenAPI document: 2.2.1
 * Contact: dl.selling.slf_sapi.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DtoAmount } from './DtoAmount';
import {
    DtoAmountFromJSON,
    DtoAmountFromJSONTyped,
    DtoAmountToJSON,
} from './DtoAmount';
import type { DtoCustomerServiceRef } from './DtoCustomerServiceRef';
import {
    DtoCustomerServiceRefFromJSON,
    DtoCustomerServiceRefFromJSONTyped,
    DtoCustomerServiceRefToJSON,
} from './DtoCustomerServiceRef';
import type { DtoEmbedded } from './DtoEmbedded';
import {
    DtoEmbeddedFromJSON,
    DtoEmbeddedFromJSONTyped,
    DtoEmbeddedToJSON,
} from './DtoEmbedded';
import type { DtoExternalOrderKey } from './DtoExternalOrderKey';
import {
    DtoExternalOrderKeyFromJSON,
    DtoExternalOrderKeyFromJSONTyped,
    DtoExternalOrderKeyToJSON,
} from './DtoExternalOrderKey';
import type { DtoFamilyCard } from './DtoFamilyCard';
import {
    DtoFamilyCardFromJSON,
    DtoFamilyCardFromJSONTyped,
    DtoFamilyCardToJSON,
} from './DtoFamilyCard';
import type { DtoFileAttachment } from './DtoFileAttachment';
import {
    DtoFileAttachmentFromJSON,
    DtoFileAttachmentFromJSONTyped,
    DtoFileAttachmentToJSON,
} from './DtoFileAttachment';
import type { DtoInternalMessage } from './DtoInternalMessage';
import {
    DtoInternalMessageFromJSON,
    DtoInternalMessageFromJSONTyped,
    DtoInternalMessageToJSON,
} from './DtoInternalMessage';
import type { DtoMessage } from './DtoMessage';
import {
    DtoMessageFromJSON,
    DtoMessageFromJSONTyped,
    DtoMessageToJSON,
} from './DtoMessage';
import type { DtoNotification } from './DtoNotification';
import {
    DtoNotificationFromJSON,
    DtoNotificationFromJSONTyped,
    DtoNotificationToJSON,
} from './DtoNotification';
import type { DtoReservation } from './DtoReservation';
import {
    DtoReservationFromJSON,
    DtoReservationFromJSONTyped,
    DtoReservationToJSON,
} from './DtoReservation';
import type { DtoTSPMessage } from './DtoTSPMessage';
import {
    DtoTSPMessageFromJSON,
    DtoTSPMessageFromJSONTyped,
    DtoTSPMessageToJSON,
} from './DtoTSPMessage';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
} from './Links';

/**
 * 
 * @export
 * @interface DtoOrder
 */
export interface DtoOrder {
    /**
     * 
     * @type {{ [key: string]: DtoAmount | undefined; }}
     * @memberof DtoOrder
     */
    Amounts?: { [key: string]: DtoAmount | undefined; };
    /**
     * 
     * @type {Array<DtoNotification>}
     * @memberof DtoOrder
     */
    Notifications?: Array<DtoNotification>;
    /**
     * 
     * @type {Array<DtoReservation>}
     * @memberof DtoOrder
     */
    Reservations?: Array<DtoReservation>;
    /**
     * 
     * @type {Array<DtoFamilyCard>}
     * @memberof DtoOrder
     */
    FamilyCards?: Array<DtoFamilyCard>;
    /**
     * 
     * @type {DtoEmbedded}
     * @memberof DtoOrder
     */
    _embedded?: DtoEmbedded;
    /**
     * 
     * @type {Links}
     * @memberof DtoOrder
     */
    _links?: Links;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    buCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DtoOrder
     */
    cashAndCarryOrder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    creationMethod?: string;
    /**
     * 
     * @type {Array<DtoCustomerServiceRef>}
     * @memberof DtoOrder
     */
    customerServicesRef?: Array<DtoCustomerServiceRef>;
    /**
     * 
     * @type {boolean}
     * @memberof DtoOrder
     */
    deviationResolved?: boolean;
    /**
     * 
     * @type {DtoExternalOrderKey}
     * @memberof DtoOrder
     */
    externalOrderKey?: DtoExternalOrderKey;
    /**
     * 
     * @type {boolean}
     * @memberof DtoOrder
     */
    hasCustomWorktopDrawing?: boolean;
    /**
     * 
     * @type {Array<DtoMessage>}
     * @memberof DtoOrder
     */
    messages?: Array<DtoMessage>;
    /**
     * 
     * @type {Array<DtoFileAttachment>}
     * @memberof DtoOrder
     */
    fileAttachments?: Array<DtoFileAttachment>;
    /**
     * 
     * @type {Array<DtoTSPMessage>}
     * @memberof DtoOrder
     */
    tspMessages?: Array<DtoTSPMessage>;
    /**
     * 
     * @type {Array<DtoInternalMessage>}
     * @memberof DtoOrder
     */
    internalMessages?: Array<DtoInternalMessage>;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    orderCreationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    orderCurrencyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    orderExpireDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    orderNo?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    orderNoSource?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    orderStatus?: DtoOrderOrderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    customerMeetingPointId?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    customerMeetingPointName?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    orderType?: DtoOrderOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    userIdCreated?: string;
    /**
     * 
     * @type {number}
     * @memberof DtoOrder
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    orderCreationClientSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoOrder
     */
    orderAlias?: string;
}


/**
 * @export
 */
export const DtoOrderOrderStatusEnum = {
    CREATED: 'CREATED',
    IN_PROGRESS: 'IN_PROGRESS',
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED',
    unknown_default_open_api: '11184809'
} as const;
export type DtoOrderOrderStatusEnum = typeof DtoOrderOrderStatusEnum[keyof typeof DtoOrderOrderStatusEnum];

/**
 * @export
 */
export const DtoOrderOrderTypeEnum = {
    SHLIST: 'SHLIST',
    SALESORDER: 'SALESORDER',
    ISOM: 'ISOM',
    DISTR: 'DISTR',
    PRICEOFFER: 'PRICEOFFER',
    PRCOFFISOM: 'PRCOFFISOM',
    unknown_default_open_api: '11184809'
} as const;
export type DtoOrderOrderTypeEnum = typeof DtoOrderOrderTypeEnum[keyof typeof DtoOrderOrderTypeEnum];


/**
 * Check if a given object implements the DtoOrder interface.
 */
export function instanceOfDtoOrder(value: object): boolean {
    return true;
}

export function DtoOrderFromJSON(json: any): DtoOrder {
    return DtoOrderFromJSONTyped(json, false);
}

export function DtoOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): DtoOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'Amounts': json['Amounts'] == null ? undefined : (mapValues(json['Amounts'], DtoAmountFromJSON)),
        'Notifications': json['Notifications'] == null ? undefined : ((json['Notifications'] as Array<any>).map(DtoNotificationFromJSON)),
        'Reservations': json['Reservations'] == null ? undefined : ((json['Reservations'] as Array<any>).map(DtoReservationFromJSON)),
        'FamilyCards': json['FamilyCards'] == null ? undefined : ((json['FamilyCards'] as Array<any>).map(DtoFamilyCardFromJSON)),
        '_embedded': json['_embedded'] == null ? undefined : DtoEmbeddedFromJSON(json['_embedded']),
        '_links': json['_links'] == null ? undefined : LinksFromJSON(json['_links']),
        'buCode': json['buCode'] == null ? undefined : json['buCode'],
        'cashAndCarryOrder': json['cashAndCarryOrder'] == null ? undefined : json['cashAndCarryOrder'],
        'creationMethod': json['creationMethod'] == null ? undefined : json['creationMethod'],
        'customerServicesRef': json['customerServicesRef'] == null ? undefined : ((json['customerServicesRef'] as Array<any>).map(DtoCustomerServiceRefFromJSON)),
        'deviationResolved': json['deviationResolved'] == null ? undefined : json['deviationResolved'],
        'externalOrderKey': json['externalOrderKey'] == null ? undefined : DtoExternalOrderKeyFromJSON(json['externalOrderKey']),
        'hasCustomWorktopDrawing': json['hasCustomWorktopDrawing'] == null ? undefined : json['hasCustomWorktopDrawing'],
        'messages': json['messages'] == null ? undefined : ((json['messages'] as Array<any>).map(DtoMessageFromJSON)),
        'fileAttachments': json['fileAttachments'] == null ? undefined : ((json['fileAttachments'] as Array<any>).map(DtoFileAttachmentFromJSON)),
        'tspMessages': json['tspMessages'] == null ? undefined : ((json['tspMessages'] as Array<any>).map(DtoTSPMessageFromJSON)),
        'internalMessages': json['internalMessages'] == null ? undefined : ((json['internalMessages'] as Array<any>).map(DtoInternalMessageFromJSON)),
        'orderCreationDate': json['orderCreationDate'] == null ? undefined : json['orderCreationDate'],
        'orderCurrencyCode': json['orderCurrencyCode'] == null ? undefined : json['orderCurrencyCode'],
        'orderExpireDate': json['orderExpireDate'] == null ? undefined : json['orderExpireDate'],
        'orderNo': json['orderNo'] == null ? undefined : json['orderNo'],
        'orderNoSource': json['orderNoSource'] == null ? undefined : json['orderNoSource'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'customerMeetingPointId': json['customerMeetingPointId'] == null ? undefined : json['customerMeetingPointId'],
        'customerMeetingPointName': json['customerMeetingPointName'] == null ? undefined : json['customerMeetingPointName'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'userIdCreated': json['userIdCreated'] == null ? undefined : json['userIdCreated'],
        'version': json['version'] == null ? undefined : json['version'],
        'orderCreationClientSystem': json['orderCreationClientSystem'] == null ? undefined : json['orderCreationClientSystem'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'orderAlias': json['orderAlias'] == null ? undefined : json['orderAlias'],
    };
}

export function DtoOrderToJSON(value?: DtoOrder | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'Amounts': value['Amounts'] == null ? undefined : (mapValues(value['Amounts'], DtoAmountToJSON)),
        'Notifications': value['Notifications'] == null ? undefined : ((value['Notifications'] as Array<any>).map(DtoNotificationToJSON)),
        'Reservations': value['Reservations'] == null ? undefined : ((value['Reservations'] as Array<any>).map(DtoReservationToJSON)),
        'FamilyCards': value['FamilyCards'] == null ? undefined : ((value['FamilyCards'] as Array<any>).map(DtoFamilyCardToJSON)),
        '_embedded': DtoEmbeddedToJSON(value['_embedded']),
        '_links': LinksToJSON(value['_links']),
        'buCode': value['buCode'],
        'cashAndCarryOrder': value['cashAndCarryOrder'],
        'creationMethod': value['creationMethod'],
        'customerServicesRef': value['customerServicesRef'] == null ? undefined : ((value['customerServicesRef'] as Array<any>).map(DtoCustomerServiceRefToJSON)),
        'deviationResolved': value['deviationResolved'],
        'externalOrderKey': DtoExternalOrderKeyToJSON(value['externalOrderKey']),
        'hasCustomWorktopDrawing': value['hasCustomWorktopDrawing'],
        'messages': value['messages'] == null ? undefined : ((value['messages'] as Array<any>).map(DtoMessageToJSON)),
        'fileAttachments': value['fileAttachments'] == null ? undefined : ((value['fileAttachments'] as Array<any>).map(DtoFileAttachmentToJSON)),
        'tspMessages': value['tspMessages'] == null ? undefined : ((value['tspMessages'] as Array<any>).map(DtoTSPMessageToJSON)),
        'internalMessages': value['internalMessages'] == null ? undefined : ((value['internalMessages'] as Array<any>).map(DtoInternalMessageToJSON)),
        'orderCreationDate': value['orderCreationDate'],
        'orderCurrencyCode': value['orderCurrencyCode'],
        'orderExpireDate': value['orderExpireDate'],
        'orderNo': value['orderNo'],
        'orderNoSource': value['orderNoSource'],
        'orderStatus': value['orderStatus'],
        'customerMeetingPointId': value['customerMeetingPointId'],
        'customerMeetingPointName': value['customerMeetingPointName'],
        'orderType': value['orderType'],
        'userIdCreated': value['userIdCreated'],
        'version': value['version'],
        'orderCreationClientSystem': value['orderCreationClientSystem'],
        'countryCode': value['countryCode'],
        'orderAlias': value['orderAlias'],
    };
}

